import Input from '@porterin/component-library/src/base-components/input/Input';
import React, { forwardRef } from 'react';

type inputInteractions = {
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
};

type inputOptions = {
  disabled?: boolean;
  placeholder?: string;
  error?: string;
  label: string;
  required?: boolean;
};

type identifiers = {
  id: string;
};

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  identifiers: identifiers;
  interactions?: inputInteractions;
  inputOptions?: inputOptions;
  className?: string;
}

const TextInputV2 = forwardRef<HTMLInputElement, InputProps>(
  (
    { identifiers, interactions, inputOptions, className = '', ...props },
    ref,
  ) => {
    return (
      <div className="relative w-[12rem]" id={identifiers?.id}>
        <label
          htmlFor={`input-${identifiers.id}`}
          className="block font-semibold text-[1.4rem] leading-[2rem] text-[#2d2f34]"
        >
          {inputOptions?.label}
          {inputOptions?.required && <span className="text-[#eb5757]"> *</span>}
        </label>

        <Input
          identifiers={{ id: `input-${identifiers.id}` }}
          interactions={interactions}
          inputOptions={inputOptions}
          ref={ref}
          className={`
            w-full outline-none bg-white font-inherit 
            leading-[1.8rem] text-[1.2rem] font-normal text-ellipsis my-[0.2rem]
            p-0 placeholder-gray-400 focus:placeholder-gray-300 border-none shadow-none
            ${className}
          `}
          {...props}
        />

        <div className="min-h-[3rem] mt-[0.4rem]">
          {inputOptions?.error && (
            <span className="font-semibold text-[1rem] leading-[1.4rem] text-[#eb5757]">
              {inputOptions.error}
            </span>
          )}
        </div>
      </div>
    );
  },
);
TextInputV2.displayName = 'TextInputV2';
export default TextInputV2;
